// removed by extract-text-webpack-plugin
module.exports = {"PresentationItem":"PresentationItem","PresentationItem__description":"PresentationItem__description","PresentationItem__description-pc":"PresentationItem__description-pc","PresentationItem__description-mb":"PresentationItem__description-mb","PresentationItem__media":"PresentationItem__media","PresentationItem__image":"PresentationItem__image"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/presentation-item/styles.css
// module id = 812
// module chunks = 0 1